import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ThirdPartyService } from '../../third-party.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { PrivilegesService } from 'src/app/services/privileges.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import * as moment from 'moment';
import { LayoutService, NavbarBtn } from 'src/app/layout/layout.service';
import { Subscription } from 'rxjs';
import { SubscriptionsService } from 'src/app/services/subscriptions.service';

@Component({
  selector: 'app-service-near-dashboard',
  templateUrl: './service-near-dashboard.component.html',
  styleUrls: ['./service-near-dashboard.component.scss']
})
export class ServiceNearDashboardComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;

  expandStatusList: boolean = false;
  msg: string = null;
  moment: any = moment;
  workOrders: any[] = [];
  searchForm: FormGroup;
  isSearchActive: boolean = false;
  orderStatuses: any[] = [];
  mainStatuses: any[] = []; //all and pending status
  toolbarData: any = {};
  filterForm: FormGroup;
  selectedShop: any;
  assignedWorkOnly: boolean = false;
  shopList: any[] = [];
  userList: any[] = [];
  timeOptions = ['Custom', 'Today', 'This Week', 'This Month', 'This Quarter', 'Last 6 Months', 'This Year'];
  defaultDateFilterTime = this.timeOptions[4];
  isFiltered: boolean = false;
  statusForm: FormGroup;
  isSearchFocused: boolean = false;
  userStatus: any;
  statusAccess: any[] = [];
  defaultFilterUser: any = null;
  defaultAssignOnlyStatus: any = null;
  defaultStatus: string = "";
  clearFilters: boolean = false
  statusList: any[] = [];
  allStatusListString: string = "";

  // lazy load vriables
  throttle = 300;
  scrollDistance = 3;
  scrollUpDistance = 1.5;
  isEndOfList = false;
  isLazyloading: boolean = false;

  skeletonCount = 5; // number of skeleton cards to show while loading
  isLoading: boolean = true;
  isCountLoading: boolean = true;

  branchID: any = 0;
  userID: any = 0;

  statusParams = {
    key: '',
    takeAll: true,
    skip: 0,
    take: 0,
    isDateChecked: true,
    fromDate: '',
    toDate: '',
    branchID: '',
    userType: ''
  }

  workOrdersParams = {
    key: "",
    takeAll: false,
    skip: 0,
    take: 50,
    shopID: 0,
    keyWord: "",
    statusType: "All",
    isDateChecked: false,
    fromDate: "2025-04-28 2:48PM",
    toDate: "2025-07-28 2:48PM",
    branchID: "",
    createdUser: "",
    assignedUser: "",
    paymentType: "",
    filterByReminderDate: false,
    isSentReminder: "",
    branchName: "",
    shopName: "",
    staffName: "",
    isShop: false,
    userAvailableStatuses: '',
    combineAssignedUserWithSearch: ''
  }

  workOrderCountParams = {
    key: "",
    takeAll: true,
    skip: 0,
    take: 50,
    shopID: 0,
    keyWord: "",
    statusType: "",
    isDateChecked: false,
    fromDate: "2023-04-28 2:48PM",
    toDate: "2025-07-28 2:48PM",
    branchID: "",
    createdUser: "",
    assignedUser: "",
    paymentType: "",
    filterByReminderDate: false,
    isSentReminder: "",
    branchName: "",
    shopName: "",
    staffName: "",
    isShop: true,
    userAvailableStatuses: '',
    combineAssignedUserWithSearch: ''
  }

  userParams = {
    key: "",
    takeAll: true,
    skip: 0,
    take: 0,
    isDateChecked: false,
    fromDate: "2025-07-20T08:12:52.876Z",
    toDate: "2025-07-20T08:12:52.876Z",
    branchID: "",
    userType: ""
  }
  layoutSubscription = new Subscription;

  constructor(
    private thirdPartyService: ThirdPartyService,
    private fb: FormBuilder,
    public privilegeService: PrivilegesService,
    private router: Router,
    private route: ActivatedRoute,
    private layoutService: LayoutService,
    public subscriptionsService: SubscriptionsService,
  ) {
  }

  ngOnInit(): void {
    this.privilegeService.getUserPrivileges();
    this.getUserAndBranchID();
    this.setFilterForm();
    this.setSearchForm();
    this.setStatusFilter();
    this.loadFromStorage();

    this.layoutSubscription.add(
      this.layoutService.routeReattached$.pipe(filter((k: string) => k === 'servicenear/dashboard')).subscribe(() => this.refreshToolbar())
    );
  }

  ngAfterViewInit() {
  }

  ngOnDestroy(): void {
    this.layoutSubscription.unsubscribe();
  }

  public getUserAndBranchID() {
    this.thirdPartyService.getStaffIdAndBrandchId().subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        let response = res?.ResponseData
        this.branchID = response.BranchId
        this.userID = response.UserId;
        this.workOrdersParams.branchID = this.branchID;
        this.workOrderCountParams.branchID = this.branchID;
        this.userParams.branchID = this.branchID;
        this.workOrdersParams.skip = 0;
        const { fromDate, toDate } = this.getDateRange(this.defaultDateFilterTime);
        this.workOrdersParams.isDateChecked = true;
        this.workOrdersParams.fromDate = fromDate;
        this.workOrdersParams.toDate = toDate;
        this.workOrderCountParams.isDateChecked = true;
        this.workOrderCountParams.fromDate = fromDate;
        this.workOrderCountParams.toDate = toDate;
        this.userFilterPrivileges();
        this.getUserPriveleges();
        this.getShops();
        this.getUsers();
        this.getStatusList();
        this.getWorkOrdersCount();
        this.getWorkOrders();
        this.populateToolbarData();
      }
    }, (error: HttpErrorResponse) => {
      this.isLoading = false;
    });
  }

  public getStatusList() {
    this.statusParams.branchID = String(this.branchID)
    this.thirdPartyService.getStatusList(this.statusParams).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        this.statusList = res?.ResponseData;
        this.allStatusListString = this.statusList.map(s => s.Status).join(',');
      }
    }, (error: HttpErrorResponse) => {
      this.isLoading = false;
    });
  }

  public toggleClearFilter() {
    this.clearFilters = !this.clearFilters;
  }

  private getUserPriveleges() {
    const privilegeStatus = localStorage.getItem('sevicenearStatus');
    if (privilegeStatus) {
      this.userStatus = JSON.parse(privilegeStatus);
      const statusList = this.userStatus;
      this.statusAccess = statusList.filter(item => item.allowed === true);
      const statusString = this.statusAccess.map(item => item.status).join(',');
      this.workOrderCountParams.userAvailableStatuses = statusString;
      this.workOrdersParams.userAvailableStatuses = statusString;
      const defaultStatusOnload = localStorage.getItem('privileges');
      const parsedDefaultStatusOnload = JSON.parse(defaultStatusOnload)?.defaultStatus;
      if (parsedDefaultStatusOnload) {
        this.defaultStatus = parsedDefaultStatusOnload;
      } else {
        this.defaultStatus = 'All';
      }
      this.workOrdersParams.statusType = this.defaultStatus;
    } else {
      console.warn("Error Parsing Privileges");
    }
  }

  private userFilterPrivileges() {
    this.workOrdersParams.assignedUser = '';
    this.workOrdersParams.createdUser = '';
    this.workOrderCountParams.assignedUser = '';
    this.workOrderCountParams.createdUser = '';
    if (this.privilegeService.getServicenearPrivilege('filterByUser', false)) {
      // CASE 1: created & assinged in 'OR'
      this.workOrdersParams.assignedUser = String(this.userID);
      this.workOrdersParams.createdUser = String(this.userID);
      this.workOrdersParams.combineAssignedUserWithSearch = 'true';
      this.workOrderCountParams.assignedUser = String(this.userID);
      this.workOrderCountParams.createdUser = String(this.userID);
      this.workOrderCountParams.combineAssignedUserWithSearch = 'true';
      this.filterForm.get('user')?.patchValue(String(this.userID));
      this.filterForm.get('assignedOnly')?.patchValue(false);
      this.defaultFilterUser = String(this.userID);
      this.defaultAssignOnlyStatus = false;
    }
    if (this.privilegeService.getServicenearPrivilege('filterByAssigned', false)) {
      // CASE 2: assigned
      this.workOrdersParams.assignedUser = String(this.userID);
      this.workOrdersParams.createdUser = '';
      this.workOrderCountParams.assignedUser = String(this.userID);
      this.workOrderCountParams.createdUser = '';
      this.filterForm.get('user')?.patchValue(String(this.userID));
      this.filterForm.get('assignedOnly')?.patchValue(true);
      this.defaultFilterUser = String(this.userID);
      this.defaultAssignOnlyStatus = true;
    }
  }

  public clearAllFilters() {
    this.toggleClearFilter();
    this.workOrdersParams.isDateChecked = false;
    this.workOrdersParams.assignedUser = '';
    this.workOrdersParams.createdUser = '';
    this.workOrdersParams.shopID = 0;
    this.workOrdersParams.userAvailableStatuses = this.allStatusListString;
    this.workOrdersParams.statusType = 'All';
    this.workOrders = [];
    this.getWorkOrders();
  }

  public applyAllFilters() {
    this.toggleClearFilter();
    this.workOrders = [];
    this.workOrdersParams.isDateChecked = true;
    this.userFilterPrivileges();
    this.workOrdersParams.statusType = this.defaultStatus;
    this.getWorkOrders();
  }

  public FilterWorkOrders() {

    if (this.filterForm.get('time')?.value) {
      const { fromDate, toDate } = this.getDateRange(this.filterForm.get('time')?.value);
      this.workOrdersParams.isDateChecked = true;
      this.workOrdersParams.fromDate = fromDate;
      this.workOrdersParams.toDate = toDate;

      this.workOrderCountParams.isDateChecked = true;
      this.workOrderCountParams.fromDate = fromDate;
      this.workOrderCountParams.toDate = toDate;
    } else {
      this.workOrdersParams.isDateChecked = false;
      this.workOrderCountParams.isDateChecked = false;
    }
    this.workOrdersParams.shopID = this.filterForm.get('shop')?.value;
    this.workOrderCountParams.shopID = this.filterForm.get('shop')?.value;
    if (this.filterForm.get('assignedOnly')?.value) {
      this.workOrdersParams.assignedUser = this.filterForm.get('user')?.value;
      this.workOrdersParams.createdUser = "";
      this.workOrderCountParams.assignedUser = this.filterForm.get('user')?.value;
      this.workOrderCountParams.createdUser = "";
    } else {
      this.workOrdersParams.assignedUser = this.filterForm.get('user')?.value;
      this.workOrdersParams.createdUser = this.filterForm.get('user')?.value;
      this.workOrdersParams.combineAssignedUserWithSearch = 'true';
      this.workOrderCountParams.assignedUser = this.filterForm.get('user')?.value;
      this.workOrderCountParams.createdUser = this.filterForm.get('user')?.value;
      this.workOrderCountParams.combineAssignedUserWithSearch = 'true';
    }
    if (this.getActiveFilters().length !== 0) {
      this.isFiltered = true;
    }
    this.workOrders = [];
    this.getWorkOrdersCount();
    this.getWorkOrders();
  }

  private setSearchForm() {
    this.searchForm = this.fb.group({
      search: [""]
    });
    this.searchForm.controls['search'].valueChanges
      .pipe(
        debounceTime(300), // wait 300ms after typing
        distinctUntilChanged(), // only emit if value changed
        tap(() => {
          this.isLoading = true;
        }),
        switchMap((str: string) => {
          this.workOrdersParams.keyWord = str;
          this.workOrdersParams.skip = 0;
          if (str && str.trim().length > 0) {
          } else {
            this.workOrders = null;
            this.clearFilters = false;
            this.workOrdersParams.shopID = this.filterForm.get('shop')?.value;
            this.userFilterPrivileges();
            this.workOrdersParams.statusType = this.defaultStatus;
          }
          return this.thirdPartyService.getWorkOrdersWithTotal(this.workOrdersParams);
        }),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (res: any) => {
          this.workOrders = res?.ResponseData.WorkOrders;
          this.getWorkOrderTransactionDetails(this.workOrders);
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Failed to fetch work orders', err);
          this.isLoading = false;
        }
      });
  }

  private setFilterForm() {
    this.filterForm = this.fb.group({
      shop: [null],
      time: [this.defaultDateFilterTime],
      fromDate: [null],
      toDate: [null],
      user: [null],
      assignedOnly: [false],
      shopSearchText: [''],
    });

    this.filterForm.get('fromDate')?.valueChanges.subscribe(() => {
      this.validateCustomDate('fromDate', 'toDate');
    });
    this.filterForm.get('toDate')?.valueChanges.subscribe(() => {
      this.validateCustomDate('toDate', 'fromDate');
    });
  }

  private validateCustomDate(selectedElement, pairElement) {
    const fromDate = this.filterForm.get(selectedElement)?.value;
    if (fromDate && new Date(fromDate) > new Date()) {
      this.filterForm.get(selectedElement)?.setValue(new Date().toISOString().split("T")[0]);
    } else if (selectedElement === 'fromDate' && this.filterForm.get(pairElement)?.value < this.filterForm.get(selectedElement)?.value) {
      this.filterForm.get(pairElement)?.setValue(this.filterForm.get(selectedElement)?.value);
    } else if (selectedElement === 'toDate' && this.filterForm.get(pairElement)?.value > this.filterForm.get(selectedElement)?.value) {
      this.filterForm.get(pairElement)?.setValue(this.filterForm.get(selectedElement)?.value);
    }
  }

  private setStatusFilter() {
    this.statusForm = this.fb.group({
      status: [""]
    });
  }

  private getWorkOrders(isScrollGet: boolean = false) {
    this.msg = null;
    this.isLoading = !isScrollGet;
    this.thirdPartyService.getWorkOrdersWithTotal(this.workOrdersParams).subscribe((res: any) => {
      this.isLazyloading = false;
      this.isLoading = false;
      if (res && res?.Result == "Success" && res?.ResponseData && res?.ResponseData !== "Failed") {
        const newOrders = res.ResponseData.WorkOrders || [];
        this.getWorkOrderTransactionDetails(newOrders);
        this.workOrders.push(...newOrders);
        // this.workOrders = res?.ResponseData.WorkOrders;
        if (newOrders.length < this.workOrdersParams.take) {
          this.isEndOfList = true;
        }
        if (this.workOrders.length === 0) {
          this.msg = "No work orders found.";
        }
      }
    },
      (error: HttpErrorResponse) => {
        this.msg = null;
        this.isLazyloading = false;
        this.isLoading = false;
      }
    );
  }

  private getWorkOrderTransactionDetails(workOrders) {
    const itemIds = workOrders
      .filter(order => order.SalesPosOrderId && parseInt(order.SalesPosOrderId) !== 0)
      .map(order => order.SalesPosOrderId);

    this.thirdPartyService.getPaymentTransactionDetails(itemIds).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {

        const transactionDetails: {
          BillNo: string,
          FinalPrice: number,
          Id: number,
          PaidAmount: number,
          PaymentModesValue: string
        }[] = res.ResponseData;

        transactionDetails.forEach(ordertran => {
          const workOrder = this.workOrders.find(order => order.SalesPosOrderId && parseInt(order.SalesPosOrderId) === ordertran.Id);
          if (workOrder) {
            workOrder.paidAmount = ordertran.PaidAmount;
          }
        });

      }
    },
      (error: HttpErrorResponse) => { });
  }

  public navigateToJobDetails(itemId: any) {
    const { thirdpartyuserkey, thirdpartyappurl } = this.route.snapshot.queryParams;
    this.router.navigate(['/servicenear/serviceDetails'], { queryParams: { workID: itemId, thirdpartyuserkey, thirdpartyappurl } });
  }

  public navigateToAddJob() {
    const { thirdpartyuserkey, thirdpartyappurl } = this.route.snapshot.queryParams;
    this.router.navigate(['/servicenear/serviceAdd'], { queryParams: { thirdpartyuserkey, thirdpartyappurl } });
  }

  private getWorkOrdersCount() {
    this.isCountLoading = true;
    this.thirdPartyService.getWorkOrdersCount(this.workOrderCountParams).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        const allOrderStatuses = res?.ResponseData;
        const allStatus = allOrderStatuses.find(status => status.StatusLabel === 'All');
        if (this.statusAccess.length > 0) {
          const accessibleOrderStatuses = this.statusAccess.map(status => status.status);
          const otherStatuses = allOrderStatuses.filter(status => accessibleOrderStatuses.includes(status.StatusLabel));
          this.orderStatuses = [allStatus, ...otherStatuses];
        }
      }
      this.isCountLoading = false;
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.isCountLoading = false;
      })
  }

  getDay(isoDate: string) {
    const date = new Date(isoDate);
    const day = date.getDate().toString().padStart(2, '0'); // DD
    return day;
  }

  getMonth(isoDate: string) {
    const date = new Date(isoDate);
    const month = date.toLocaleString('en-US', { month: 'short' }); // MMM
    return month;
  }

  getMonthAndYear(isoDate: string) {
    const date = new Date(isoDate);
    const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase(); // MMM
    const year = date.getFullYear(); // YYYY
    return `${month} ${year}`;
  }

  private refreshToolbar() {
    this.layoutService.setToolbar({
      title: 'DASHBOARD',
    });
    this.layoutService.setNavbarButtons([
      { action: 'expressjob', state: null, icon: '', image: 'assets/images/exp_job.png' }
    ]);
  }

  private populateToolbarData() {
    this.refreshToolbar();

    this.layoutSubscription.add(this.layoutService.buttonClicked$.subscribe((btn: NavbarBtn) => {

      if (!btn) return;

      switch (btn.action) {
        case 'expressjob':
          const { thirdpartyuserkey, thirdpartyappurl } = this.route.snapshot.queryParams;
          this.router.navigate(['/servicenear/serviceAdd/expressjob'], { queryParams: { thirdpartyuserkey, thirdpartyappurl } });
          break;
      }
    }));
  }

  public lightenColor(hex: string = '#000000', opacity: number = 0.2) {
    if (!hex || typeof hex !== 'string') {
      return '';
    }
    hex = hex.replace(/^#/, '');
    if (hex.length !== 6 && hex.length !== 3) {
      return '';
    }
    if (hex.length === 3) {
      hex = hex.split('').map(x => x + x).join('');
    }
    const bigint = parseInt(hex, 16);
    if (isNaN(bigint)) {
      return '';
    }
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  private getShops() {
    this.thirdPartyService.getShops(this.userID).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        this.shopList = res?.ResponseData;
        localStorage.setItem('shopList', JSON.stringify(this.shopList));
      }
    }, (error: HttpErrorResponse) => {
      console.log(error);
    })
  }

  private getDateRange(option) {
    const now = new Date();
    let fromDate = new Date(now); // clone
    let toDate = new Date(now);
    switch (option) {
      case 'Today': {
        fromDate.setDate(now.getDate());
        fromDate.setHours(0, 0, 0, 0);
        break;
      }
      case 'This Week': {
        const day = now.getDay(); // 0 (Sun) - 6 (Sat)
        const diff = day; // number of days to subtract to reach Sunday
        fromDate.setDate(now.getDate() - diff);
        fromDate.setHours(0, 0, 0, 0);
        break;
      }
      case 'This Month': {
        fromDate = new Date(now.getFullYear(), now.getMonth(), 1);
        break;
      }
      case 'This Quarter': {
        fromDate.setMonth(now.getMonth() - 3);
        break;
      }
      case 'Last 6 Months': {
        fromDate.setMonth(now.getMonth() - 6);
        break;
      }
      case 'This Year': {
        fromDate = new Date(now.getFullYear(), 0, 1);
        break;
      }
      case 'Custom': {
        fromDate = new Date(this.filterForm.get('fromDate')?.value);
        toDate = new Date(this.filterForm.get('toDate')?.value);
        break;
      }
      default: {
        fromDate = new Date(now);
      }
    }
    return {
      fromDate: this.formatDateforPayload(fromDate),
      toDate: this.formatDateforPayload(toDate)
    };
  }

  private formatDateforPayload(date) {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months: 0–11
    const dd = String(date.getDate()).padStart(2, '0');
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours === 0 ? 12 : hours; // 0 → 12
    const hh = String(hours).padStart(2, '0');
    return `${yyyy}-${mm}-${dd} ${hh}:${minutes}${ampm}`;
  }

  public getUsers() {
    this.thirdPartyService.getBranchUsers(this.userParams).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        this.userList = res?.ResponseData;
        localStorage.setItem('userList', JSON.stringify(this.userList));
      }
    },
      (error: HttpErrorResponse) => {
        console.log(error);
      });
  }

  public getActiveFilters() {
    const form = this.filterForm.value;
    const filters = [];
    if (form.shop) {
      const shopname = this.shopList.find(shop => shop.BranchID === form.shop)?.ShopName;
      filters.push({ key: 'shop', label: 'Shop', display: shopname });
      // this.toolbarData.isShopFiltered = true;
      // this.toolbarData.ShopName = shopname || '';

      this.layoutService.setToolbar({
        title: 'DASHBOARD',
        isShopFiltered: true,
        shopName: shopname || ''
      });
    } else {
      // this.toolbarData.isShopFiltered = false;
      // this.toolbarData.ShopName = ""

      this.layoutService.setToolbar({
        title: 'DASHBOARD',
        isShopFiltered: false,
        shopName: ''
      });
    }
    if (form.time && this.workOrdersParams.isDateChecked === true) {
      const timeFilter = form.time === 'Custom' ? `${moment(form.fromDate).format('DD/MMM/YY')} - ${moment(form.toDate).format('DD/MMM/YY')}` : form.time;
      filters.push({ key: 'time', label: 'Time', display: timeFilter });
    }
    if (form.user) {
      const username = this.userList.find(user => user.UserID === form.user)?.Name;
      filters.push({ key: 'user', label: 'User', display: username });
    }
    if (form.length === 0) {
      this.isFiltered = false;
    }
    return filters;
  }

  public removeAllFilter() {
    const defaultValues = {
      shop: null,
      time: null,
      user: null,
      assignedOnly: false,
      shopSearchText: ''
    };
    this.filterForm.patchValue(defaultValues);
    if (this.filterForm.get('time')?.value) {
      const { fromDate, toDate } = this.getDateRange(this.filterForm.get('time')?.value);
      this.workOrdersParams.isDateChecked = true;
      this.workOrdersParams.fromDate = fromDate;
      this.workOrdersParams.toDate = toDate;
      this.workOrderCountParams.isDateChecked = true;
      this.workOrderCountParams.fromDate = fromDate;
      this.workOrderCountParams.toDate = toDate;
    } else {
      this.workOrdersParams.isDateChecked = false;
      this.workOrderCountParams.isDateChecked = false;
    }
    this.workOrdersParams.shopID = this.filterForm.get('shop')?.value;
    this.workOrderCountParams.shopID = this.filterForm.get('shop')?.value;
    if (this.getActiveFilters().length !== 0) {
      this.isFiltered = true;
    }
    this.userFilterPrivileges();
    this.workOrders = [];
    this.getWorkOrdersCount();
    this.getWorkOrders();
    this.isEndOfList = false;
  }

  public onScroll() {
    if (!this.isLazyloading && !this.isEndOfList && this.workOrdersParams.branchID) {
      this.isLazyloading = true;
      this.workOrdersParams.skip += this.workOrdersParams.take;
      this.getWorkOrders(true);
    }
  }

  public addStatusFilter(status: any) {
    this.workOrdersParams.statusType = status.StatusLabel;
    this.workOrdersParams.skip = 0;
    this.isEndOfList = false;
    this.workOrders = [];
    window.scrollTo(0, 0); // Reset the scroll to top
    this.getWorkOrders();
  }

  get searchControl() {
    return this.searchForm.get('search');
  }

  public clearSearch() {
    this.searchForm.reset();
    this.isSearchFocused = false;
  }

  private loadFromStorage() {
    const shopList = localStorage.getItem('shopList');
    const userList = localStorage.getItem('userList');

    if (shopList) this.shopList = JSON.parse(shopList);
    if (userList) this.userList = JSON.parse(userList);
  }

}
